export const SLIDER_IMAGE_TYPES = {
  ROOM: 'room',
  USER: 'user',
};
